import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject, combineLatest, Subject, Subscription} from 'rxjs';
import {UnitGroupModel} from '../../unit/unit-group/unit-group.model';
import {UnitGroupsService} from './unit-groups.service';
import {map, throttleTime} from 'rxjs/operators';

@Component({
  selector: 'app-unit-groups',
  templateUrl: './unit-groups.component.html',
  styleUrls: ['./unit-groups.component.scss']
})
export class UnitGroupsComponent implements OnInit, OnDestroy {

  @Input() unitId: BehaviorSubject<number>;

  unitGroups: BehaviorSubject<UnitGroupModel[] | null> = new BehaviorSubject<UnitGroupModel[] | null>(null);
  reloadUnitGroupsSubject: Subject<boolean> = new Subject<boolean>();

  subscriptions: Subscription[] = [];

  constructor(
    private unitGroupsService: UnitGroupsService
  ) { }

  ngOnInit() {
    this.subscriptions.push(
      combineLatest(
        this.unitId,
        this.reloadUnitGroupsSubject
      ).pipe(
        map(([unitId, ]) => unitId),
        throttleTime(50),
      ).subscribe(
        unitId => {
          this.unitGroupsService.getGroupsOfUnit(unitId).subscribe(
            groups => {
              console.log(groups);
              this.unitGroups.next(groups);
            }
          );
        }
      )
    );
    this.reloadUnitGroups();
  }

  reloadUnitGroups() {
    this.reloadUnitGroupsSubject.next(true);
  }
  onDeleteConfirmed(unitGroup: UnitGroupModel) {
    this.unitGroupsService.removeUnitFromGroup(
      this.unitId.getValue(),
      unitGroup.id
    ).subscribe(
      () => this.reloadUnitGroups(),
      // result => { },
      // error => { }
    );
  }

  onAddToGroupResult(result) {
    if (result) {
      this.reloadUnitGroups();
    }
  }
  ngOnDestroy() {
    this.subscriptions.filter(s => !!s).forEach(s => s.unsubscribe());
  }
}
